const MASKED_VALUE = "masked-value";

/** Utility function to mask all query params of a URL string
 *
 * @param args.url - The URL string to mask
 * @param args.whitelist - The query parameters to whitelist
 * @returns The masked URL
 */
export function maskQueryParamsFromUrl(
  url: string,
  whitelist?: string[]
): string {
  return maskQueryParams({
    urlOrPath: url,
    whitelist: whitelist
  }).toString();
}

/** Utility function to mask all query params of a URL or path string
 *
 * @param args.urlOrPath - The URL or path string to mask
 * @param args.base - The base URL to use if the URL or path is only a path
 * @param whitelist - The query parameters to whitelist
 * @returns The masked URL
 */
function maskQueryParams(args: {
  urlOrPath: string;
  base?: string;
  whitelist?: string[];
}): URL {
  // Build a new URL object in case url is a string
  const newUrl = new URL(args.urlOrPath, args.base);

  // Iterate over each query parameter and replace its value with "masked-value"
  newUrl.searchParams.forEach((_value, key) => {
    if (!args.whitelist?.includes(key)) {
      newUrl.searchParams.set(key, MASKED_VALUE);
    }
  });

  return newUrl;
}
